var LaboratoryProfileEnum = /* @__PURE__ */ ((LaboratoryProfileEnum2) => {
  LaboratoryProfileEnum2["LABORATORY_PROFILE_SECTION_STRUCTURE"] = "section-structure--laboratory-profile";
  LaboratoryProfileEnum2["LABORATORY_PROFILE_SECTION_ADDRESS"] = "section-address--laboratory-profile";
  LaboratoryProfileEnum2["LABORATORY_PROFILE_SECTION_RATING"] = "section-rating--laboratory-profile";
  LaboratoryProfileEnum2["LABORATORY_PROFILE_GALLERY_IMAGE"] = "gallery-image--gallery-component";
  return LaboratoryProfileEnum2;
})(LaboratoryProfileEnum || {});
export {
  LaboratoryProfileEnum
};
